// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AlertBox_wrapper__3AHZh","icon":"AlertBox_icon__1C9lA","text":"AlertBox_text__3mZDh"};